// export const BACKEND_API = "http://localhost:8080/";
export const BACKEND_API = "https://bullbull.herokuapp.com/";
